const BscMainnetAddresses = {
  ORACLE_ADDRESS: "0x7Cd53b71Bf56Cc6C9c9B43719FE98e7c360c35DF",
  FACTOR_REGISTRY_ADDRESS: "0xD11fba861283174CBCb1FD0a475e420aa955bE61",
  POOL_LOGIC_ADDRESS: "0xC21E063e15E4b6B52149dE9Df9Ba31E69B4a63ee",
  POOL_CONFIGURATOR_LOGIC_ADDRESS: "0x2D3b21A0659ba864ba0E330721bCC5B981F82c6e",
  T_TOKEN_LOGIC_ADDRESS: "0xF16f6b41509F2b748586b93f5da91E32e9422469",
  DEBT_TOKEN_LOGIC_ADDRESS: "0xBb6D1Ba6089309B09FB5E81ff37309C1A086B74a",
  TREASURY_ADDRESS: "0x7dc13842F3353636cD47ca2823B26efD0389ed55",
  INCENTIVES_ADDRESS: "0x4c481E66798c6C82aF77d1e14d3233fE5D592A0b",
  TRAVA_TOKEN_ADDRESS: "0x0391bE54E72F7e001f6BBc331777710b4f2999Ef",
  STAKED_TRAVA_TOKEN_ADDRESS: "0x170772A06aFfC0d375cE90Ef59C8eC04c7ebF5D2",
  GATEWAY_ADDRESS: "0xeB528330ae1208E319b91a5BB717b6c37ADB389b",
  POOL_UPDATE_CONTROLLER: "0x8f7447d8bb4eDfC6B92B95C133a0F4A5eb54698d",
  ADDRESS_PROVIDER_FACTORY: "0x88D3a207E4D58cb80cAEA720f3c275B10F0c9000",
};

export default BscMainnetAddresses;
